import React from "react";
import { Calendar } from "lucide-react";

interface EmptyStateProps {
  title: string;
  children?: React.ReactNode;
}

export default function EmptyState({ title, children }: EmptyStateProps) {
  return (
    <div className="mt-8 rounded-2xl border border-light-gray-alt dark:border-deep-purple/50 bg-white dark:bg-soft-black px-8 py-12 text-center text-soft-black/70 dark:text-light-gray">
      <div className="mx-auto mb-4 grid h-16 w-16 place-items-center rounded-full bg-darling-lilac/10 dark:bg-darling-lilac/20">
        <Calendar className="h-8 w-8 text-darling-lilac" />
      </div>
      <h3 className="text-lg font-exo font-bold text-soft-black dark:text-white mb-2">{title}</h3>
      {children && <p className="text-sm font-exo font-light">{children}</p>}
    </div>
  );
}